/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { OrderedFileDtoFromJSON, OrderedFileDtoToJSON, } from './';
export function CarAttachmentsDtoFromJSON(json) {
    return CarAttachmentsDtoFromJSONTyped(json, false);
}
export function CarAttachmentsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'attachments': !exists(json, 'attachments') ? undefined : (json['attachments'] === null ? null : json['attachments'].map(OrderedFileDtoFromJSON)),
    };
}
export function CarAttachmentsDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'attachments': value.attachments === undefined ? undefined : (value.attachments === null ? null : value.attachments.map(OrderedFileDtoToJSON)),
    };
}
